import React from "react";

const Roadmap = () => {
    const milestones = [
        {
            subtitle: "Completed!",
            title: "Q2 2023 - Q4 2024",
            details: [
                "No Limit Hold'em Cash Game",
                "No Limit Hold'em Tournaments",
                "Wallet Connections",
                "Arbitrum Network Support",
                "Full Mobile Support",
                "USDT Freeroll Tests",
            ],
        },
        {
            subtitle: "Completed!",
            title: "Q1 2025",
            details: [
                "Redesign UI - Revamp site and game front",
                "Backend improvements",
                "Platform contracts Audit",
                "Tokenomics and roadmap introduction to the community",
            ],
        },
        {
            title: "Q2 2025",
            details: [
                "Platform Beta Launch",
                "Utility Token Giveaway",
                "Tournament NFT Vouchers"
            ]
        },
        {
            title: "Q3 2025",
            details: [
                "Fair Launch utility token",
                "ZTpoker Clans",
                "Jack Poker Cash Game",
                "Jack Poker Tournaments",
            ]
        },
        {
            title: "Q4 2025",
            details: [
                "Double D Cash Game",
                "Double D Tournaments",
                "Pot Limit Omaha Cash Game",
                "Pot Limit Omaha Tournaments"
            ],
        },
        {
            title: "Q1 2026",
            details: [
                "Zero Trust Casino Launch",
            ],
        },
    ];

    return (
        <div id="roadmap" className="roadmap-area">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <h2 className="text-center top-reveal">Our Roadmap</h2>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-12">
                        <div className="roadmap-content">
                            {milestones.map((milestone, index) => (
                                <div className="roadmap-box top-reveal" key={index}>
                                    {milestone.subtitle && <span>{milestone.subtitle}</span>}
                                    <h3>{milestone.title}</h3>
                                    {milestone.date && <div className="date">{milestone.date}</div>}
                                    {milestone.details && Array.isArray(milestone.details) && (
                                        <ul className="list">
                                            {milestone.details.map((detail, i) => (
                                                <li key={i}>{detail}</li>
                                            ))}
                                        </ul>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Roadmap;
